import { z } from 'zod';

// ── Items ──────────────────────────────────────────────────────────────────

const ItemBody = z.string().min(1).max(500);

export const ChecklistItemSchema = z.object({
  id: z.string().uuid(),
  checklistId: z.string().uuid(),
  body: z.string(),
  isCompleted: z.boolean(),
  completedBy: z.string().uuid().nullable(),
  completedAt: z.string().nullable(),
  dueDate: z.string().nullable(),
  assignedTo: z.string().uuid().nullable(),
  orderIndex: z.number().int().nonnegative(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type ChecklistItemProjection = z.infer<typeof ChecklistItemSchema>;

export const CreateChecklistItemSchema = z
  .object({
    body: ItemBody,
    dueDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).nullable().optional(),
    assignedTo: z.string().uuid().nullable().optional(),
  })
  .strict();
export type CreateChecklistItemInput = z.infer<typeof CreateChecklistItemSchema>;

export const UpdateChecklistItemSchema = z
  .object({
    body: ItemBody.optional(),
    isCompleted: z.boolean().optional(),
    dueDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).nullable().optional(),
    assignedTo: z.string().uuid().nullable().optional(),
    orderIndex: z.number().int().nonnegative().optional(),
  })
  .strict();
export type UpdateChecklistItemInput = z.infer<typeof UpdateChecklistItemSchema>;

// ── Checklist (list of items) ─────────────────────────────────────────────

const ChecklistName = z.string().min(1).max(80);

export const ChecklistSchema = z.object({
  id: z.string().uuid(),
  taskId: z.string().uuid(),
  name: z.string(),
  orderIndex: z.number().int().nonnegative(),
  createdBy: z.string().uuid(),
  createdAt: z.string(),
  updatedAt: z.string(),
  items: z.array(ChecklistItemSchema),
});
export type ChecklistProjection = z.infer<typeof ChecklistSchema>;

export const ChecklistListSchema = z.array(ChecklistSchema);

export const CreateChecklistSchema = z
  .object({
    name: ChecklistName.optional(),
  })
  .strict();
export type CreateChecklistInput = z.infer<typeof CreateChecklistSchema>;

export const UpdateChecklistSchema = z
  .object({
    name: ChecklistName.optional(),
    orderIndex: z.number().int().nonnegative().optional(),
  })
  .strict();
export type UpdateChecklistInput = z.infer<typeof UpdateChecklistSchema>;
